import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  appName: { es: "MFIS Supply-Chain", en: "MFIS Supply-Chain" },
  tagline: { es: "by OOMINING", en: "by OOMINING" },
  // nav
  "nav.dashboard": { es: "Panel", en: "Dashboard" },
  "nav.addressBook": { es: "Libreta de Direcciones", en: "Address Book" },
  "nav.items": { es: "Maestro de Artículos", en: "Item Master" },
  "nav.classifications": { es: "Clasificaciones", en: "Classifications" },
  "nav.equipment": { es: "Equipos", en: "Equipment" },
  "nav.cardex": { es: "Cardex de Inventario", en: "Inventory Cardex" },
  "nav.requisitions": { es: "Requisiciones", en: "Requisitions" },
  "nav.purchaseOrders": { es: "Órdenes de Compra", en: "Purchase Orders" },
  "nav.receipts": { es: "Recepciones", en: "Receipts" },
  "nav.match": { es: "Conciliación 3 Vías", en: "3-Way Match" },
  "nav.settings": { es: "Ajustes", en: "Settings" },
  "nav.inbox": { es: "Mi Escritorio", en: "My Inbox" },
  "nav.personnel": { es: "Personal del Proyecto", en: "Project Personnel" },
  "nav.departments": { es: "Departamentos", en: "Departments" },
  "nav.vales": { es: "Vales de Salida", en: "Exit Vouchers" },
  "nav.core": { es: "NÚCLEO", en: "CORE" },
  "nav.procurement": { es: "COMPRAS", en: "PROCUREMENT" },
  "nav.system": { es: "SISTEMA", en: "SYSTEM" },
  // login
  "login.title": { es: "Acceso al sistema", en: "System access" },
  "login.subtitle": { es: "Plataforma privada de MFIS Supply-Chain", en: "Private MFIS Supply-Chain platform" },
  "login.email": { es: "Correo electrónico", en: "Email" },
  "login.password": { es: "Contraseña", en: "Password" },
  "login.submit": { es: "Iniciar sesión", en: "Sign in" },
  "login.demo": { es: "Cuentas demo (clic para llenar)", en: "Demo accounts (click to fill)" },
  "login.success": { es: "Bienvenido", en: "Welcome" },
  "login.forgot": { es: "¿Olvidaste tu contraseña?", en: "Forgot your password?" },
  "login.tutorial": { es: "Ver tutorial completo", en: "View full tutorial" },
  "login.hero1": { es: "Cadena de suministro industrial. Sin licencias.", en: "Industrial supply-chain. No licensing." },
  "login.hero2": { es: "Cardex inmutable · 3-Way Match · RBAC granular", en: "Immutable Cardex · 3-Way Match · Granular RBAC" },
  // Privacy / Security / Backups (public info on Login)
  "info.privacy.title": { es: "Aviso de privacidad", en: "Privacy notice" },
  "info.privacy.body": {
    es: "OOMINING - mining software (Chihuahua, México) es responsable del tratamiento de los datos personales que ingreses en esta plataforma. Recabamos: nombre, correo electrónico, teléfono y datos de contacto laboral, con la única finalidad de operar los procesos de compras, almacén y proveedores del sistema. No compartimos ni vendemos tus datos a terceros. Puedes ejercer tus derechos ARCO (Acceso, Rectificación, Cancelación, Oposición) o revocar tu consentimiento enviando un correo a oswaldo.cereceres@oomining.com. Los datos se conservan durante la relación laboral/comercial y por el plazo legal aplicable. Este aviso cumple con la LFPDPPP (México).",
    en: "OOMINING - mining software (Chihuahua, Mexico) is responsible for the processing of the personal data you enter on this platform. We collect: name, email, phone and work contact data, with the sole purpose of operating the procurement, warehouse and supplier processes of the system. We do not share or sell your data to third parties. You may exercise your ARCO rights (Access, Rectification, Cancellation, Opposition) or revoke consent by emailing oswaldo.cereceres@oomining.com. Data is kept for the duration of the working/commercial relationship and the applicable legal period."
  },
  "info.security.title": { es: "Seguridad anti-hackeo", en: "Anti-hacking security" },
  "info.security.body": {
    es: "Nivel de seguridad implementado: contraseñas cifradas con bcrypt (irreversible), autenticación por JWT firmado con secreto de 64 hex, cookies httpOnly + Secure + SameSite Lax, bloqueo automático tras 5 intentos fallidos (15 min), roles granulares (RBAC), validación estricta de todos los montos y cantidades, anti-inyección de fórmulas en exportes Excel/PDF, escape de regex en búsquedas, cabeceras CORS restringidas, y auditoría inmutable de movimientos en el Cardex. Sistema auditado sin vulnerabilidades críticas.",
    en: "Implemented security level: bcrypt-hashed passwords (one-way), JWT auth with 64-hex secret, httpOnly + Secure + SameSite Lax cookies, automatic lockout after 5 failed attempts (15 min), granular role-based access (RBAC), strict validation of amounts and quantities, formula-injection protection in Excel/PDF exports, regex-escape in searches, restricted CORS headers, and immutable Cardex audit log. Audited with no critical vulnerabilities."
  },
  "info.backups.title": { es: "Respaldos continuos", en: "Continuous backups" },
  "info.backups.body": {
    es: "El sistema realiza respaldos comprimidos y encriptados (gzip + JSON completo de todas las colecciones) cada 6 horas de forma automática, conservando las últimas 10 copias con rotación. Antes de cualquier restauración se genera un respaldo de seguridad. El administrador puede además ejecutar, descargar o restaurar respaldos manualmente desde la interfaz o subir un respaldo externo (.json.gz).",
    en: "The system performs compressed & encrypted backups (gzip + full JSON of all collections) every 6 hours automatically, keeping the last 10 copies via rotation. A safety backup is always created before any restore. Admins can manually run, download or restore backups from the UI or upload an external backup file (.json.gz)."
  },
  // Forgot / Reset password
  "fp.title": { es: "Restablecer contraseña", en: "Reset password" },
  "fp.subtitle": { es: "Ingresa tu correo y te enviaremos un enlace para restablecerla.", en: "Enter your email and we'll send you a reset link." },
  "fp.email": { es: "Correo electrónico", en: "Email" },
  "fp.submit": { es: "Enviar enlace", en: "Send link" },
  "fp.sent": { es: "Si el correo existe en el sistema, recibirás un enlace en unos minutos. Revisa spam.", en: "If the email exists, you'll receive a link shortly. Check spam." },
  "fp.back": { es: "Volver al inicio de sesión", en: "Back to login" },
  "rp.title": { es: "Nueva contraseña", en: "New password" },
  "rp.subtitle": { es: "Elige una contraseña de al menos 8 caracteres.", en: "Choose a password of at least 8 characters." },
  "rp.new": { es: "Nueva contraseña", en: "New password" },
  "rp.confirm": { es: "Confirma la contraseña", en: "Confirm password" },
  "rp.mismatch": { es: "Las contraseñas no coinciden", en: "Passwords do not match" },
  "rp.short": { es: "Mínimo 8 caracteres", en: "At least 8 characters" },
  "rp.submit": { es: "Restablecer", en: "Reset" },
  "rp.success": { es: "Contraseña actualizada. Puedes iniciar sesión.", en: "Password updated. You can sign in." },
  "rp.notoken": { es: "Enlace inválido o expirado", en: "Invalid or expired link" },
  // Tutorial
  "tut.title": { es: "Tutorial completo A-Z", en: "Full A-Z tutorial" },
  "tut.subtitle": { es: "Guía visual del sistema MFIS Supply-Chain", en: "Visual guide to MFIS Supply-Chain" },
  "tut.backLogin": { es: "Volver al login", en: "Back to login" },
  "tut.toc": { es: "Contenido", en: "Contents" },
  "nav.tutorial": { es: "Manual / Tutorial", en: "Manual / Tutorial" },
  // Settings — brand
  "st.brand": { es: "Marca y apariencia", en: "Brand & appearance" },
  "st.logoMark": { es: "Iniciales del logo (máx 4)", en: "Logo initials (max 4)" },
  "st.appSubtitle": { es: "Subtítulo (aparece bajo el nombre)", en: "Subtitle (shown under the name)" },
  "st.brandTagline": { es: "Lema / tagline (línea intermedia)", en: "Tagline (middle line)" },
  // common
  "common.actions": { es: "Acciones", en: "Actions" },
  "common.save": { es: "Guardar", en: "Save" },
  "common.cancel": { es: "Cancelar", en: "Cancel" },
  "common.create": { es: "Crear", en: "Create" },
  "common.new": { es: "Nuevo", en: "New" },
  "common.edit": { es: "Editar", en: "Edit" },
  "common.search": { es: "Buscar...", en: "Search..." },
  "common.status": { es: "Estatus", en: "Status" },
  "common.date": { es: "Fecha", en: "Date" },
  "common.user": { es: "Usuario", en: "User" },
  "common.warehouse": { es: "Almacén", en: "Warehouse" },
  "common.item": { es: "Artículo", en: "Item" },
  "common.description": { es: "Descripción", en: "Description" },
  "common.qty": { es: "Cantidad", en: "Qty" },
  "common.cost": { es: "Costo", en: "Cost" },
  "common.total": { es: "Total", en: "Total" },
  "common.uom": { es: "UM", en: "UOM" },
  "common.active": { es: "Activo", en: "Active" },
  "common.inactive": { es: "Inactivo", en: "Inactive" },
  "common.importCsv": { es: "Importar CSV", en: "Import CSV" },
  "common.template": { es: "Plantilla", en: "Template" },
  "common.loading": { es: "Cargando...", en: "Loading..." },
  "common.noData": { es: "Sin registros", en: "No records" },
  "common.logout": { es: "Cerrar sesión", en: "Log out" },
  "common.all": { es: "Todos", en: "All" },
  "common.refresh": { es: "Actualizar", en: "Refresh" },
  "common.lines": { es: "Líneas", en: "Lines" },
  "common.addLine": { es: "Agregar línea", en: "Add line" },
  "common.notes": { es: "Notas", en: "Notes" },
  "common.supplier": { es: "Proveedor", en: "Supplier" },
  "common.number": { es: "Número", en: "Number" },
  "common.approve": { es: "Aprobar", en: "Approve" },
  "common.reject": { es: "Rechazar", en: "Reject" },
  "common.view": { es: "Ver", en: "View" },
  "common.saved": { es: "Guardado correctamente", en: "Saved successfully" },
  "common.created": { es: "Creado correctamente", en: "Created successfully" },
  "common.optional": { es: "opcional", en: "optional" },
  "common.any": { es: "Cualquiera", en: "Any" },
  "common.confirm": { es: "Confirmar", en: "Confirm" },
  "common.history": { es: "Historial", en: "History" },
  "common.add": { es: "Agregar", en: "Add" },
  "common.required": { es: "Requerido", en: "Required" },
  // roles
  "role.admin": { es: "Administrador", en: "Admin" },
  "role.buyer": { es: "Comprador", en: "Buyer" },
  "role.approver": { es: "Aprobador", en: "Approver" },
  "role.warehouse": { es: "Almacenista", en: "Warehouse" },
  "role.viewer": { es: "Visor", en: "Viewer" },
  "role.maintenance": { es: "Mantenimiento", en: "Maintenance" },
  "role.supplier": { es: "Proveedor", en: "Supplier" },
  // statuses
  "st.pending": { es: "Pendiente", en: "Pending" },
  "st.approved": { es: "Aprobada", en: "Approved" },
  "st.rejected": { es: "Rechazada", en: "Rejected" },
  "st.draft": { es: "En captura", en: "Draft" },
  "st.converted": { es: "Convertida", en: "Converted" },
  "st.open": { es: "Abierta", en: "Open" },
  "st.pending_l1": { es: "Pend. encargado depto", en: "Pending dept. head" },
  "st.pending_l2": { es: "Pend. nivel 2", en: "Pending level 2" },
  "loc.binOptional": { es: "Bin (opcional)", en: "Bin (optional)" },
  "st.partial": { es: "Parcial", en: "Partial" },
  "st.received": { es: "Recibida", en: "Received" },
  "st.cancelled": { es: "Cancelada", en: "Cancelled" },
  "st.ok": { es: "OK", en: "OK" },
  "st.qty_mismatch": { es: "Dif. Cantidad", en: "Qty Mismatch" },
  "st.cost_mismatch": { es: "Dif. Costo", en: "Cost Mismatch" },
  // dashboard
  "dash.title": { es: "Panel de Control", en: "Dashboard" },
  "dash.pendingReqs": { es: "Requisiciones pendientes", en: "Pending requisitions" },
  "dash.openPos": { es: "OC abiertas", en: "Open POs" },
  "dash.invValue": { es: "Valor de inventario", en: "Inventory value" },
  "dash.items": { es: "Artículos activos", en: "Active items" },
  "dash.pendingInvoices": { es: "Facturas por conciliar", en: "Invoices to match" },
  "dash.poByStatus": { es: "OC por estatus", en: "POs by status" },
  "dash.invByWh": { es: "Inventario por almacén", en: "Inventory by warehouse" },
  "dash.recentMoves": { es: "Últimos movimientos (Cardex)", en: "Recent movements (Cardex)" },
  "dash.invByFamily": { es: "Inventario por Familia (Valor actual)", en: "Inventory by Family (Current value)" },
  "dash.familyCode": { es: "Código familia", en: "Family code" },
  "dash.familyName": { es: "Familia", en: "Family" },
  "dash.itemsCount": { es: "Artículos", en: "Items" },
  "dash.qtyOnHand": { es: "Cantidad", en: "Qty on hand" },
  "dash.currentValue": { es: "Valor actual", en: "Current value" },
  // system health
  "sh.title": { es: "Salud del Sistema", en: "System Health" },
  "sh.lastBackup": { es: "Último respaldo", en: "Last backup" },
  "sh.autoBackup": { es: "Auto-respaldo", en: "Auto-backup" },
  "sh.lastMrp": { es: "Última corrida MRP", en: "Last MRP run" },
  "sh.autoMrp": { es: "MRP programado", en: "Scheduled MRP" },
  "sh.emails": { es: "Correos MRP (histórico)", en: "MRP emails (all-time)" },
  "sh.emailsSent": { es: "Enviados", en: "Sent" },
  "sh.emailsFailed": { es: "Fallidos", en: "Failed" },
  "sh.emailsNo": { es: "Sin destinatario", en: "No recipient" },
  "sh.resend": { es: "Servicio Resend", en: "Resend service" },
  "sh.configured": { es: "Configurado", en: "Configured" },
  "sh.notConfigured": { es: "No configurado", en: "Not configured" },
  "sh.enabled": { es: "Activo", en: "Enabled" },
  "sh.disabled": { es: "Inactivo", en: "Disabled" },
  "sh.every": { es: "cada", en: "every" },
  "sh.hours": { es: "h", en: "h" },
  "sh.none": { es: "Sin datos", en: "No data" },
  "sh.recentRuns": { es: "Últimas 5 corridas MRP", en: "Last 5 MRP runs" },
  "sh.mode": { es: "Modo", en: "Mode" },
  "sh.pos": { es: "OCs", en: "POs" },
  "sh.by": { es: "Por", en: "By" },
  "sh.modeManual": { es: "Manual", en: "Manual" },
  "sh.modeAuto": { es: "Automático", en: "Automatic" },
  "sh.mrpTotals": { es: "Total histórico: {runs} corridas · {pos} OCs generadas", en: "All-time: {runs} runs · {pos} POs generated" },
  // address book
  "ab.title": { es: "Libreta de Direcciones", en: "Address Book" },
  "ab.subtitle": { es: "Maestro único de proveedores, empleados y clientes", en: "Single master for suppliers, employees and customers" },
  "ab.supplier": { es: "Proveedor", en: "Supplier" },
  "ab.employee": { es: "Empleado", en: "Employee" },
  "ab.customer": { es: "Cliente", en: "Customer" },
  "ab.name": { es: "Nombre / Razón social", en: "Name / Legal name" },
  "ab.taxId": { es: "RFC / Tax ID", en: "Tax ID" },
  "ab.contact": { es: "Contacto", en: "Contact" },
  "ab.phone": { es: "Teléfono", en: "Phone" },
  "ab.address": { es: "Dirección", en: "Address" },
  "ab.type": { es: "Tipo", en: "Type" },
  "ab.new": { es: "Nuevo registro", en: "New entry" },
  // items
  "it.title": { es: "Maestro de Artículos", en: "Item Master" },
  "it.subtitle": { es: "Catálogo central con UOM, conversiones y control de lotes", en: "Central catalog with UOM, conversions and lot control" },
  "it.number": { es: "No. Artículo", en: "Item No." },
  "it.category": { es: "Categoría", en: "Category" },
  "it.uomP": { es: "UM Primaria", en: "Primary UOM" },
  "it.uomS": { es: "UM Secundaria", en: "Secondary UOM" },
  "it.factor": { es: "Factor conv.", en: "Conv. factor" },
  "it.lot": { es: "Lote", en: "Lot" },
  "it.stdCost": { es: "Costo estándar", en: "Standard cost" },
  "it.stdCostHint": { es: "Solo comprador · úsalo al registrar un artículo desde una OC real", en: "Buyer only · when registering an item from an actual PO" },
  "it.minStock": { es: "Stock mínimo (seguridad)", en: "Min stock (safety)" },
  "it.maxStock": { es: "Stock máximo (target)", en: "Max stock (target)" },
  "it.reorderPoint": { es: "Punto de reorden", en: "Reorder point" },
  "it.stockPolicyHelp": { es: "MRP dispara al bajar del punto de reorden y compra hasta el stock máximo.", en: "MRP triggers when qty drops below reorder point and purchases up to max stock." },
  "it.new": { es: "Nuevo artículo", en: "New item" },
  "it.import": { es: "Importar Excel/CSV", en: "Import Excel/CSV" },
  "it.template": { es: "Plantilla Excel", en: "Excel template" },
  "it.importDone": { es: "{n} artículos importados", en: "{n} items imported" },
  "it.export": { es: "Exportar catálogo", en: "Export catalog" },
  "it.deleted": { es: "Artículo eliminado", en: "Item deleted" },
  "it.partNumber": { es: "No. de parte", en: "Part number" },
  "it.partNumberHint": { es: "del fabricante/OEM, único — evita altas duplicadas", en: "manufacturer/OEM, unique — prevents duplicate items" },
  "it.partNumberDup": { es: "Ya existe un artículo con este número de parte: {x}", en: "An item with this part number already exists: {x}" },
  "it.bulkDeleted": { es: "{n} artículo(s) eliminado(s)", en: "{n} item(s) deleted" },
  "it.selected": { es: "{n} seleccionado(s)", en: "{n} selected" },
  "it.deleteTitle": { es: "Eliminar del maestro de artículos", en: "Delete from item master" },
  "it.deleteDesc": { es: "Se eliminará: {x}. Solo se borran artículos sin existencias ni movimientos (Cardex, OC, requisiciones, vales, OTs); los que tengan historial se omiten y conviene desactivarlos. Esta acción no se puede deshacer.", en: "Will delete: {x}. Only items without stock or movements (Cardex, POs, requisitions, dispatches, WOs) are removed; items with history are skipped and should be deactivated instead. This cannot be undone." },
  "it.classification": { es: "Clasificación (auto-genera código)", en: "Classification (auto-generates code)" },
  "it.autoCode": { es: "Código automático", en: "Auto code" },
  // Classifications
  "cls.title": { es: "Clasificaciones", en: "Classifications" },
  "cls.subtitle": { es: "Estructura: Familia → Grupo → Subgrupo. El código se usa al generar el código de artículo.", en: "Structure: Family → Group → Subgroup. Codes are used when generating item numbers." },
  "cls.family": { es: "Familia", en: "Family" },
  "cls.group": { es: "Grupo", en: "Group" },
  "cls.subgroup": { es: "Subgrupo", en: "Subgroup" },
  "cls.code": { es: "Código (2-4 letras)", en: "Code (2-4 letters)" },
  "cls.codeHelp": { es: "Ej: MEC, BOM, CEN. Se combinan para el código de artículo (MEC-BOM-CEN-0001).", en: "Ex: MEC, BOM, CEN. Combined into the item number (MEC-BOM-CEN-0001)." },
  "cls.name": { es: "Nombre", en: "Name" },
  "cls.new.family": { es: "Nueva familia", en: "New family" },
  "cls.new.group": { es: "Nuevo grupo", en: "New group" },
  "cls.new.subgroup": { es: "Nuevo subgrupo", en: "New subgroup" },
  "cls.familyExample": { es: "Ej: MEC (Mecánica), ELE (Eléctrica), CON (Consumibles)", en: "Ex: MEC (Mechanical), ELE (Electrical), CON (Consumables)" },
  "cls.selectAbove": { es: "—", en: "—" },
  "cls.selectFamily": { es: "Selecciona una familia", en: "Select a family" },
  "cls.selectGroup": { es: "Selecciona un grupo", en: "Select a group" },
  "cls.confirmDelete": { es: "¿Eliminar esta clasificación? Solo se puede si no tiene hijos ni artículos asociados.", en: "Delete this classification? Only if it has no children or associated items." },
  // Equipment
  "eq.title": { es: "Maestro de Equipos", en: "Equipment Master" },
  "eq.subtitle": { es: "Catálogo de equipos para vincular a partidas de requisición (refaccionamiento)", en: "Equipment catalog to link to requisition lines (parts management)" },
  "eq.new": { es: "Nuevo equipo", en: "New equipment" },
  "eq.code": { es: "Código", en: "Code" },
  "eq.name": { es: "Nombre / Descripción", en: "Name / Description" },
  "eq.tag": { es: "TAG", en: "TAG" },
  "eq.area": { es: "Área", en: "Area" },
  "eq.location": { es: "Ubicación física", en: "Physical location" },
  "eq.confirmDelete": { es: "¿Eliminar este equipo?", en: "Delete this equipment?" },
  "eq.equipmentFor": { es: "Equipo", en: "Equipment" },
  "eq.import": { es: "Importar CSV", en: "Import CSV" },
  "eq.template": { es: "Plantilla CSV", en: "CSV template" },
  "eq.importDone": { es: "Importados: {created} · Omitidos: {skipped}", en: "Imported: {created} · Skipped: {skipped}" },
  // Classifications import / seed
  "cls.import": { es: "Importar CSV", en: "Import CSV" },
  "cls.template": { es: "Plantilla CSV", en: "CSV template" },
  "cls.seed": { es: "Sembrar base minera", en: "Seed mining base" },
  "cls.seedConfirm": { es: "Se agregarán las familias/grupos/subgrupos estándar de minería (MEC, ELE, CON, INS, CIV, TI) y 20 equipos base. Los códigos existentes se omiten. ¿Continuar?", en: "Standard mining families/groups/subgroups (MEC, ELE, CON, INS, CIV, TI) and 20 base equipments will be added. Existing codes are skipped. Continue?" },
  "cls.seedDone": { es: "Clasificaciones creadas: {c1} (omitidas {s1}) · Equipos creados: {c2} (omitidos {s2})", en: "Classifications created: {c1} (skipped {s1}) · Equipment created: {c2} (skipped {s2})" },
  "cls.importDone": { es: "Importados: {created} · Omitidos: {skipped}", en: "Imported: {created} · Skipped: {skipped}" },
  // Requisitions extra
  "rq.searchItem": { es: "Buscar artículo (código, descripción, categoría)…", en: "Search item (code, description, category)…" },
  "rq.linkedPo": { es: "OC vinculada", en: "Linked PO" },
  "rq.approvedDate": { es: "Fecha aprobación", en: "Approved date" },
  "rq.createdDate": { es: "Fecha creación", en: "Created date" },
  "rq.print": { es: "Imprimir carátula", en: "Print cover sheet" },
  "rq.downloadPdf": { es: "Descargar PDF", en: "Download PDF" },
  "rq.lineEquipment": { es: "Equipo (opcional)", en: "Equipment (optional)" },
  "rq.lineNotes": { es: "Notas de línea", en: "Line notes" },
  "rq.noEquipment": { es: "Sin equipo", en: "No equipment" },
  "common.deleted": { es: "Eliminado", en: "Deleted" },
  // cardex
  "cx.title": { es: "Cardex de Inventario", en: "Inventory Cardex" },
  "cx.subtitle": { es: "Registro inmutable de transacciones. Nada se actualiza sin rastro.", en: "Immutable transaction ledger. Nothing updates without a trace." },
  "cx.movements": { es: "Movimientos", en: "Movements" },
  "cx.balances": { es: "Existencias", en: "On-hand balances" },
  "cx.docType": { es: "Tipo Doc", en: "Doc Type" },
  "cx.docNumber": { es: "No. Documento", en: "Doc Number" },
  "cx.unitCost": { es: "Costo unit.", en: "Unit cost" },
  "cx.totalCost": { es: "Costo total", en: "Total cost" },
  "cx.reference": { es: "Referencia", en: "Reference" },
  "cx.adjustment": { es: "Ajuste de inventario", en: "Inventory adjustment" },
  "cx.newAdjustment": { es: "Nuevo ajuste", en: "New adjustment" },
  "cx.reason": { es: "Motivo", en: "Reason" },
  "cx.qtyHint": { es: "Positivo = entrada, negativo = salida", en: "Positive = in, negative = out" },
  "cx.onHand": { es: "Existencia", en: "On hand" },
  "cx.avgCost": { es: "Costo prom.", en: "Avg cost" },
  "cx.value": { es: "Valor", en: "Value" },
  // requisitions
  "rq.title": { es: "Requisiciones de Compra", en: "Purchase Requisitions" },
  "rq.subtitle": { es: "Flujo: Requisición → Aprobación → Orden de Compra", en: "Flow: Requisition → Approval → Purchase Order" },
  "rq.new": { es: "Nueva requisición", en: "New requisition" },
  "rq.requester": { es: "Solicitante", en: "Requester" },
  "rq.department": { es: "Departamento", en: "Department" },
  "rq.approver": { es: "Aprobador", en: "Approver" },
  "rq.convert": { es: "Convertir a OC", en: "Convert to PO" },
  "rq.estCost": { es: "Costo est.", en: "Est. cost" },
  "rq.approved": { es: "Requisición aprobada", en: "Requisition approved" },
  "rq.rejected": { es: "Requisición rechazada", en: "Requisition rejected" },
  "rq.converted": { es: "OC generada", en: "PO created" },
  // purchase orders
  "po.title": { es: "Órdenes de Compra", en: "Purchase Orders" },
  "po.subtitle": { es: "Emisión y seguimiento de OC a proveedores", en: "Issue and track supplier POs" },
  "po.new": { es: "Nueva OC", en: "New PO" },
  "po.receivedQty": { es: "Recibido", en: "Received" },
  "po.cancel": { es: "Cancelar OC", en: "Cancel PO" },
  "po.fromReq": { es: "Requisición", en: "Requisition" },
  // receipts
  "rc.title": { es: "Recepciones de Almacén", en: "Warehouse Receipts" },
  "rc.subtitle": { es: "Recepción contra OC — genera Cardex automáticamente", en: "Receive against PO — posts to Cardex automatically" },
  "rc.new": { es: "Nueva recepción", en: "New receipt" },
  "rc.selectPo": { es: "Seleccionar OC", en: "Select PO" },
  "rc.remaining": { es: "Pendiente", en: "Remaining" },
  "rc.toReceive": { es: "A recibir", en: "To receive" },
  "rc.receivedBy": { es: "Recibió", en: "Received by" },
  "rc.post": { es: "Registrar recepción", en: "Post receipt" },
  "rc.posted": { es: "Recepción registrada en Cardex", en: "Receipt posted to Cardex" },
  // match
  "mt.title": { es: "Conciliación de 3 Vías", en: "3-Way Match" },
  "mt.subtitle": { es: "OC vs Recepción vs Factura — antes de autorizar el pago", en: "PO vs Receipt vs Invoice — before authorizing payment" },
  "mt.invoices": { es: "Facturas de proveedor", en: "Supplier invoices" },
  "mt.newInvoice": { es: "Registrar factura", en: "Register invoice" },
  "mt.supplierInvoice": { es: "Folio factura proveedor", en: "Supplier invoice no." },
  "mt.poQty": { es: "Cant. OC", en: "PO Qty" },
  "mt.poCost": { es: "Costo OC", en: "PO Cost" },
  "mt.rcQty": { es: "Cant. Recibida", en: "Received Qty" },
  "mt.invQty": { es: "Cant. Facturada", en: "Invoiced Qty" },
  "mt.invCost": { es: "Costo Facturado", en: "Invoiced Cost" },
  "mt.matchOk": { es: "Conciliación exitosa — listo para pago", en: "Match successful — ready for payment" },
  "mt.matchFail": { es: "Discrepancias detectadas — revisar antes de pagar", en: "Discrepancies found — review before payment" },
  "mt.approvePay": { es: "Autorizar pago", en: "Authorize payment" },
  "mt.forceApprove": { es: "Forzar aprobación (admin)", en: "Force approval (admin)" },
  "mt.invoiceApproved": { es: "Factura autorizada para pago", en: "Invoice authorized for payment" },
  "mt.invoiceRejected": { es: "Factura rechazada", en: "Invoice rejected" },
  // settings
  "set.title": { es: "Ajustes", en: "Settings" },
  "set.subtitle": { es: "Apariencia, idioma y usuarios del sistema", en: "Appearance, language and system users" },
  "set.appearance": { es: "Apariencia", en: "Appearance" },
  "set.darkMode": { es: "Modo oscuro", en: "Dark mode" },
  "set.language": { es: "Idioma", en: "Language" },
  "set.primaryColor": { es: "Color primario (global, solo admin)", en: "Primary color (global, admin only)" },
  "set.companyName": { es: "Nombre de la empresa", en: "Company name" },
  "set.users": { es: "Usuarios", en: "Users" },
  "set.newUser": { es: "Nuevo usuario", en: "New user" },
  "set.name": { es: "Nombre", en: "Name" },
  "set.role": { es: "Rol", en: "Role" },
  "set.password": { es: "Contraseña", en: "Password" },
  "set.colorSaved": { es: "Tema guardado para toda la empresa", en: "Theme saved company-wide" },
  // wms nav
  "nav.wms": { es: "ALMACÉN (WMS)", en: "WAREHOUSE (WMS)" },
  "nav.locations": { es: "Ubicaciones", en: "Locations" },
  "nav.transfers": { es: "Transferencias", en: "Transfers" },
  "nav.cycleCounts": { es: "Conteos Cíclicos", en: "Cycle Counts" },
  "nav.quality": { es: "Cuarentena / Calidad", en: "Quarantine / Quality" },
  "nav.scan": { es: "Escáner (Móvil)", en: "Scanner (Mobile)" },
  // stock statuses
  "st.available": { es: "Disponible", en: "Available" },
  "st.quarantine": { es: "Cuarentena", en: "Quarantine" },
  "st.hold": { es: "Retenido", en: "On Hold" },
  "st.damaged": { es: "Dañado", en: "Damaged" },
  "st.counted": { es: "Contado", en: "Counted" },
  "st.posted": { es: "Registrado", en: "Posted" },
  // locations
  "loc.title": { es: "Ubicaciones (Bins)", en: "Locations (Bins)" },
  "loc.subtitle": { es: "Estructura: Almacén > Pasillo > Rack > Ubicación", en: "Structure: Warehouse > Aisle > Rack > Bin" },
  "loc.aisle": { es: "Pasillo", en: "Aisle" },
  "loc.rack": { es: "Rack", en: "Rack" },
  "loc.bin": { es: "Ubicación (Bin)", en: "Bin" },
  "loc.code": { es: "Código", en: "Code" },
  "loc.new": { es: "Nueva ubicación", en: "New location" },
  "loc.none": { es: "(Sin ubicación)", en: "(No bin)" },
  // transfers
  "tr.title": { es: "Transferencias", en: "Transfers" },
  "tr.subtitle": { es: "Movimientos entre almacenes y ubicaciones — genera Cardex TR", en: "Moves between warehouses and bins — posts TR to Cardex" },
  "tr.new": { es: "Nueva transferencia", en: "New transfer" },
  "tr.from": { es: "Origen", en: "From" },
  "tr.to": { es: "Destino", en: "To" },
  "tr.fromWh": { es: "Almacén origen", en: "From warehouse" },
  "tr.toWh": { es: "Almacén destino", en: "To warehouse" },
  "tr.fromLoc": { es: "Ubicación origen", en: "From bin" },
  "tr.toLoc": { es: "Ubicación destino", en: "To bin" },
  "tr.post": { es: "Ejecutar transferencia", en: "Post transfer" },
  "tr.posted": { es: "Transferencia registrada en Cardex", en: "Transfer posted to Cardex" },
  // quality
  "qa.title": { es: "Cuarentena y Calidad", en: "Quarantine & Quality" },
  "qa.subtitle": { es: "Inventario en cuarentena, retenido o dañado. Liberación requiere aprobación.", en: "Quarantined, held or damaged stock. Release requires approval." },
  "qa.holds": { es: "Inventario retenido", en: "Held inventory" },
  "qa.moves": { es: "Movimientos de calidad", en: "Quality moves" },
  "qa.newMove": { es: "Mover estatus", en: "Move status" },
  "qa.fromStatus": { es: "Estatus origen", en: "From status" },
  "qa.toStatus": { es: "Estatus destino", en: "To status" },
  "qa.release": { es: "Liberar", en: "Release" },
  "qa.releaseHint": { es: "Liberar a disponible requiere rol Aprobador o Admin", en: "Release to available requires Approver or Admin role" },
  "qa.moved": { es: "Movimiento de calidad registrado", en: "Quality move posted" },
  // cycle counts
  "cc.title": { es: "Conteos Cíclicos", en: "Cycle Counts" },
  "cc.subtitle": { es: "Conteo físico vs sistema — varianzas se ajustan vía Cardex", en: "Physical vs system count — variances adjust via Cardex" },
  "cc.new": { es: "Nuevo conteo", en: "New count" },
  "cc.systemQty": { es: "Cant. sistema", en: "System qty" },
  "cc.countedQty": { es: "Cant. contada", en: "Counted qty" },
  "cc.variance": { es: "Varianza", en: "Variance" },
  "cc.saveCounts": { es: "Guardar conteo", en: "Save counts" },
  "cc.postCount": { es: "Registrar ajustes", en: "Post adjustments" },
  "cc.scope": { es: "Alcance", en: "Scope" },
  "cc.saved": { es: "Conteo guardado", en: "Count saved" },
  "cc.posted": { es: "Ajustes registrados en Cardex", en: "Adjustments posted to Cardex" },
  "cc.evidences": { es: "Evidencias", en: "Evidences" },
  "cc.evidenceUpload": { es: "Adjuntar archivo", en: "Attach file" },
  "cc.evidenceHint": { es: "Formatos permitidos: JPG, PNG, PDF, XLSX (máx. 15 MB)", en: "Allowed: JPG, PNG, PDF, XLSX (max 15 MB)" },
  "cc.evidenceUploaded": { es: "Evidencia adjuntada", en: "Evidence uploaded" },
  "cc.evidenceDeleted": { es: "Evidencia eliminada", en: "Evidence removed" },
  "cc.evidenceEmpty": { es: "Sin evidencias adjuntas", en: "No evidence attached" },
  "cc.evidenceDownload": { es: "Descargar", en: "Download" },
  "cc.evidenceDelete": { es: "Eliminar", en: "Remove" },
  "cc.evidenceConfirmDelete": { es: "¿Eliminar esta evidencia?", en: "Remove this evidence?" },
  // scan
  "scan.title": { es: "Escáner de Piso", en: "Floor Scanner" },
  "scan.subtitle": { es: "PWA móvil — escanea código QR/barras del artículo", en: "Mobile PWA — scan item QR/barcode" },
  "scan.start": { es: "Iniciar cámara", en: "Start camera" },
  "scan.stop": { es: "Detener", en: "Stop" },
  "scan.manual": { es: "O ingresa el número de artículo", en: "Or type the item number" },
  "scan.lookup": { es: "Buscar", en: "Look up" },
  "scan.notFound": { es: "Artículo no encontrado", en: "Item not found" },
  "scan.camError": { es: "No se pudo acceder a la cámara", en: "Could not access camera" },
  // receipts extras
  "rc.location": { es: "Ubicación (Bin)", en: "Bin location" },
  "rc.quarantine": { es: "Recibir en cuarentena", en: "Receive into quarantine" },
  // portal
  "pt.title": { es: "Portal de Proveedores", en: "Supplier Portal" },
  "pt.welcome": { es: "Bienvenido", en: "Welcome" },
  "pt.pos": { es: "Tus órdenes de compra", en: "Your purchase orders" },
  "pt.receipts": { es: "Recepciones", en: "Receipts" },
  "pt.invoices": { es: "Tus facturas", en: "Your invoices" },
  "pt.upload": { es: "Cargar factura", en: "Upload invoice" },
  "pt.payment": { es: "Pago programado", en: "Scheduled payment" },
  "pt.uploaded": { es: "Factura cargada — pendiente de conciliación", en: "Invoice uploaded — pending match" },
  // shipments
  "nav.shipments": { es: "Pick / Pack / Ship", en: "Pick / Pack / Ship" },
  "so.title": { es: "Embarques (Pick / Pack / Ship)", en: "Shipments (Pick / Pack / Ship)" },
  "so.subtitle": { es: "Surtido, empaque y embarque a clientes — genera Cardex SH", en: "Pick, pack and ship to customers — posts SH to Cardex" },
  "so.new": { es: "Nueva orden de salida", en: "New outbound order" },
  "so.customer": { es: "Cliente", en: "Customer" },
  "so.pick": { es: "Confirmar picking", en: "Confirm picking" },
  "so.pack": { es: "Empacar", en: "Pack" },
  "so.ship": { es: "Embarcar", en: "Ship" },
  "so.packages": { es: "Paquetes", en: "Packages" },
  "so.pickFrom": { es: "Surtir desde", en: "Pick from" },
  "so.picked": { es: "Picking confirmado", en: "Picking confirmed" },
  "so.packed": { es: "Orden empacada", en: "Order packed" },
  "so.shipped": { es: "Embarque registrado en Cardex", en: "Shipment posted to Cardex" },
  "st.picked": { es: "Surtida", en: "Picked" },
  "st.packed": { es: "Empacada", en: "Packed" },
  "st.shipped": { es: "Embarcada", en: "Shipped" },
  // budgets & approvals
  "bg.title": { es: "Aprobaciones y presupuestos", en: "Approvals & budgets" },
  "bg.limit": { es: "Límite de aprobación (arriba requiere Admin)", en: "Approval limit (above requires Admin)" },
  "bg.budgets": { es: "Presupuestos mensuales por departamento", en: "Monthly budgets by department" },
  "bg.department": { es: "Departamento", en: "Department" },
  "bg.monthly": { es: "Presupuesto mensual", en: "Monthly budget" },
  "bg.spent": { es: "Gastado (mes)", en: "Spent (month)" },
  "bg.remaining": { es: "Disponible", en: "Remaining" },
  "bg.addRow": { es: "Agregar departamento", en: "Add department" },
  "rq.forceApprove": { es: "Forzar aprobación (admin)", en: "Force approval (admin)" },
  // Requisitions v2 (draft workflow + categories + Excel + export)
  "rq.category": { es: "Categoría", en: "Category" },
  "rq.cat.monthly": { es: "Mensual", en: "Monthly" },
  "rq.cat.urgent": { es: "Urgente", en: "Urgent" },
  "rq.cat.extra_critical": { es: "Extra Crítica", en: "Extra Critical" },
  "rq.cat.restock": { es: "Reabastecimiento", en: "Restock" },
  "rq.cat.maintenance": { es: "Mantenimiento", en: "Maintenance" },
  "rq.neededBy": { es: "Fecha requerida", en: "Needed by" },
  "rq.assignApprover": { es: "Asignar aprobador", en: "Assign approver" },
  "rq.saveDraft": { es: "Guardar borrador", en: "Save draft" },
  "rq.submit": { es: "Enviar a aprobación", en: "Submit for approval" },
  "rq.submitted": { es: "Requisición enviada a aprobación", en: "Requisition submitted for approval" },
  "rq.draftSaved": { es: "Borrador guardado", en: "Draft saved" },
  "rq.edit": { es: "Editar borrador", en: "Edit draft" },
  "rq.cancel": { es: "Cancelar requisición", en: "Cancel requisition" },
  "rq.reject": { es: "Rechazar (regresa a captura)", en: "Reject (send back to draft)" },
  "rq.reason": { es: "Motivo / Observaciones", en: "Reason / Observations" },
  "rq.reasonRequired": { es: "El motivo es obligatorio (mín. 3 caracteres)", en: "Reason is required (min 3 chars)" },
  "rq.importExcel": { es: "Importar Excel", en: "Import Excel" },
  "rq.importPreview": { es: "Previsualización de importación", en: "Import preview" },
  "rq.importErrors": { es: "Errores encontrados", en: "Errors found" },
  "rq.importApply": { es: "Aplicar partidas", en: "Apply lines" },
  "rq.export": { es: "Exportar historial (Excel)", en: "Export history (Excel)" },
  "rq.filterFrom": { es: "Desde", en: "From" },
  "rq.filterTo": { es: "Hasta", en: "To" },
  "rq.filterCategory": { es: "Filtrar categoría", en: "Filter category" },
  "rq.filterStatus": { es: "Filtrar estatus", en: "Filter status" },
  "rq.filterAll": { es: "Todas", en: "All" },
  "rq.history": { es: "Historial", en: "History" },
  "rq.cancelled": { es: "Cancelada", en: "Cancelled" },
  "rq.lastRejection": { es: "Último motivo de rechazo", en: "Last rejection reason" },
  "rq.excelTemplate": { es: "Descargar plantilla Excel", en: "Download Excel template" },
  // stock alerts
  "al.title": { es: "Alertas de stock mínimo", en: "Minimum stock alerts" },
  "al.kpi": { es: "Stock bajo mínimo", en: "Below min stock" },
  "al.minStock": { es: "Mínimo", en: "Minimum" },
  "al.onHand": { es: "Disponible", en: "On hand" },
  "al.shortage": { es: "Faltante", en: "Shortage" },
  "al.estTotal": { es: "Costo est.", en: "Est. cost" },
  "al.createReq": { es: "Generar requisición", en: "Create requisition" },
  "al.reqCreated": { es: "Requisición de reabastecimiento creada", en: "Replenishment requisition created" },
  "al.none": { es: "Sin alertas — todo arriba del mínimo", en: "No alerts — everything above minimum" },
  // reports
  "rp.pdf": { es: "PDF", en: "PDF" },
  "rp.excel": { es: "Excel", en: "Excel" },
  "rp.export": { es: "Exportar", en: "Export" },
  // serials
  "nav.serials": { es: "Números de Serie", en: "Serial Numbers" },
  "sn.title": { es: "Números de Serie", en: "Serial Numbers" },
  "sn.subtitle": { es: "Trazabilidad por unidad: recepción → embarque", en: "Unit-level traceability: receipt → shipment" },
  "sn.serial": { es: "Serie", en: "Serial" },
  "sn.controlled": { es: "Serie", en: "Serial" },
  "sn.inStock": { es: "En existencia", en: "In stock" },
  "sn.shippedDoc": { es: "Doc. embarque", en: "Ship doc" },
  "sn.receipt": { es: "Recepción", en: "Receipt" },
  "sn.search": { es: "Buscar serie...", en: "Search serial..." },
  "sn.enter": { es: "Series (separadas por coma)", en: "Serials (comma separated)" },
  "sn.required": { es: "requiere números de serie", en: "requires serial numbers" },
  "st.in_stock": { es: "En existencia", en: "In stock" },
  // currencies
  "cur.title": { es: "Monedas y tipos de cambio", en: "Currencies & exchange rates" },
  "cur.code": { es: "Moneda", en: "Currency" },
  "cur.rate": { es: "Tipo de cambio (a MXN)", en: "Exchange rate (to MXN)" },
  "cur.add": { es: "Agregar moneda", en: "Add currency" },
  "cur.hint": { es: "Los costos se convierten a MXN al recibir en almacén", en: "Costs convert to MXN at warehouse receipt" },
  // mrp
  "nav.mrp": { es: "MRP / Reabastecimiento", en: "MRP / Replenishment" },
  "mrp.title": { es: "MRP — Reabastecimiento", en: "MRP — Replenishment" },
  "mrp.subtitle": { es: "Sugerencias de compra por faltante de stock mínimo, agrupadas por proveedor", en: "Purchase suggestions from min-stock shortages, grouped by supplier" },
  "mrp.noSupplier": { es: "Sin proveedor preferente", en: "No preferred supplier" },
  "mrp.generatePo": { es: "Generar OC", en: "Create PO" },
  "mrp.poCreated": { es: "OC de reabastecimiento creada", en: "Replenishment PO created" },
  "mrp.assignHint": { es: "Asigna un proveedor preferente en el Maestro de Artículos para generar la OC automática", en: "Assign a preferred supplier in the Item Master to auto-create the PO" },
  "mrp.none": { es: "Sin sugerencias — todo arriba del mínimo", en: "No suggestions — everything above minimum" },
  "it.supplier": { es: "Proveedor preferente", en: "Preferred supplier" },
  "common.delete": { es: "Eliminar", en: "Delete" },
  "ab.currency": { es: "Moneda por defecto", en: "Default currency" },
  "mrp.schedule": { es: "Corrida programada", en: "Scheduled run" },
  "mrp.auto": { es: "Automática", en: "Automatic" },
  "mrp.interval": { es: "Intervalo (hrs)", en: "Interval (hrs)" },
  "mrp.lastRun": { es: "Última corrida", en: "Last run" },
  "mrp.runNow": { es: "Ejecutar corrida ahora", en: "Run now" },
  "mrp.runDone": { es: "Corrida MRP completada", en: "MRP run completed" },
  "mrp.runs": { es: "Historial de corridas", en: "Run history" },
  "mrp.mode": { es: "Modo", en: "Mode" },
  "mrp.onOrder": { es: "En pedido", en: "On order" },
  // security & backups
  "set.changePassword": { es: "Cambiar contraseña", en: "Change password" },
  "set.currentPassword": { es: "Contraseña actual", en: "Current password" },
  "set.newPassword": { es: "Nueva contraseña", en: "New password" },
  "set.passwordChanged": { es: "Contraseña actualizada", en: "Password updated" },
  "set.passwordHint": { es: "Mínimo 8 caracteres", en: "Minimum 8 characters" },
  "bk.title": { es: "Respaldos de base de datos", en: "Database backups" },
  "bk.now": { es: "Respaldar ahora", en: "Backup now" },
  "bk.done": { es: "Respaldo creado", en: "Backup created" },
  "bk.file": { es: "Archivo", en: "File" },
  "bk.size": { es: "Tamaño", en: "Size" },
  "bk.download": { es: "Descargar", en: "Download" },
  "bk.restore": { es: "Restaurar", en: "Restore" },
  "bk.upload": { es: "Restaurar desde archivo", en: "Restore from file" },
  "bk.restoreConfirm": { es: "⚠️ Esto REEMPLAZARÁ todos los datos actuales con los del respaldo (se creará un respaldo de seguridad antes). ¿Continuar?", en: "⚠️ This will REPLACE all current data with the backup (a safety backup will be created first). Continue?" },
  "bk.restored": { es: "Base de datos restaurada", en: "Database restored" },
  "bk.safety": { es: "respaldo de seguridad", en: "safety backup" },
  // ---------------- REABASTO (Fase 15 - Panel + auto policy + alerts) ----------------
  "nav.reabasto": { es: "Panel de Reabasto", en: "Reabasto Panel" },
  "rb.title": { es: "Panel de Reabasto", en: "Restock Panel" },
  "rb.subtitle": { es: "Artículos bajo el punto de reorden con impacto de caja proyectado", en: "Items under reorder point with projected cash impact" },
  "rb.itemsCount": { es: "Artículos a comprar", en: "Items to buy" },
  "rb.criticalCount": { es: "Críticos (cobertura < 7 d)", en: "Critical (cover < 7 d)" },
  "rb.cashImpact": { es: "Impacto de caja (mes)", en: "Cash impact (month)" },
  "rb.windowDays": { es: "Ventana análisis", en: "Analysis window" },
  "rb.leadTime": { es: "Lead time", en: "Lead time" },
  "rb.days": { es: "días", en: "days" },
  "rb.item": { es: "Artículo", en: "Item" },
  "rb.onHand": { es: "Actual", en: "On hand" },
  "rb.reorder": { es: "P. Reorden", en: "Reorder" },
  "rb.max": { es: "Máx.", en: "Max" },
  "rb.shortage": { es: "A comprar", en: "To buy" },
  "rb.avgDaily": { es: "Consumo/día", en: "Avg/day" },
  "rb.projected30": { es: "Proyec. 30d", en: "Proj. 30d" },
  "rb.daysCover": { es: "Cobertura", en: "Cover" },
  "rb.estTotal": { es: "Costo est.", en: "Est. cost" },
  "rb.recalc": { es: "Recalcular políticas", en: "Recalc policies" },
  "rb.recalcTitle": { es: "Recalcular reorder_point y max_stock", en: "Recalc reorder_point and max_stock" },
  "rb.recalcHint": { es: "A partir del consumo real de los últimos 90 días.", en: "From actual consumption of last 90 days." },
  "rb.recalcPreview": { es: "Ver propuesta", en: "Preview" },
  "rb.recalcApply": { es: "Aplicar cambios", en: "Apply changes" },
  "rb.recalcDone": { es: "Políticas actualizadas para {n} artículos", en: "Policies updated for {n} items" },
  "rb.leadDays": { es: "Lead time (días)", en: "Lead time (days)" },
  "rb.coverageDays": { es: "Cobertura (días)", en: "Coverage (days)" },
  "rb.safetyFactor": { es: "Factor de seguridad", en: "Safety factor" },
  "rb.onlyWithConsumption": { es: "Solo artículos con consumo", en: "Only items with consumption" },
  "rb.proposal": { es: "Propuesta", en: "Proposal" },
  "rb.current": { es: "Actual", en: "Current" },
  "rb.noChange": { es: "Sin cambios", en: "No change" },
  "rb.sendAlert": { es: "Enviar alerta ahora", en: "Send alert now" },
  "rb.alertSent": { es: "Alerta enviada a {n} destinatarios", en: "Alert sent to {n} recipients" },
  "rb.alertSettings": { es: "Configurar alertas", en: "Alert settings" },
  "rb.alertsEnabled": { es: "Alertas activas", en: "Alerts enabled" },
  "rb.recipients": { es: "Destinatarios (correos separados por coma)", en: "Recipients (comma-separated emails)" },
  "rb.hourUtc": { es: "Hora envío (UTC)", en: "Send hour (UTC)" },
  "rb.hourUtcHint": { es: "14 UTC = 8:00 AM Chihuahua (UTC-6)", en: "14 UTC = 8:00 AM Chihuahua" },
  "rb.lastSent": { es: "Último envío", en: "Last sent" },
  "rb.settingsSaved": { es: "Configuración guardada", en: "Settings saved" },
  "rb.noItems": { es: "🎉 Todos los artículos están sobre el punto de reorden", en: "🎉 All items are above reorder point" },
  "rb.critical": { es: "CRÍTICO", en: "CRITICAL" },
  "rb.createReq": { es: "Crear requisición seleccionados", en: "Create requisition (selected)" },
  "rb.selectAll": { es: "Seleccionar todo", en: "Select all" },
  "rb.noRecipientsWarn": { es: "Sin destinatarios configurados — se enviará a tu correo (puede fallar en sandbox)", en: "No recipients configured — will send to your email (may fail in sandbox)" },
  // Semáforo
  "it.stockLight": { es: "Estado", en: "Stock" },
  "it.light.red": { es: "Bajo reorden", en: "Below reorder" },
  "it.light.yellow": { es: "Entre reorden y máximo", en: "Between reorder & max" },
  "it.light.green": { es: "Sobre máximo", en: "Above max" },
  "it.light.grey": { es: "Sin política", en: "No policy" },
  // Simulador Compras
  "rb.simulator": { es: "Simulador de compras", en: "Purchase simulator" },
  "rb.simulateTitle": { es: "OCs sugeridas por proveedor preferente", en: "Suggested POs by preferred supplier" },
  "rb.simulateHint": { es: "Agrupa los artículos a comprar por proveedor. Puedes generar OCs reales al aplicar.", en: "Groups items to buy by supplier. You can create real POs on apply." },
  "rb.simulateRun": { es: "Simular", en: "Simulate" },
  "rb.simulateApply": { es: "Generar OCs", en: "Create POs" },
  "rb.simulateDone": { es: "{n} OCs generadas", en: "{n} POs created" },
  "rb.unassigned": { es: "Sin proveedor preferente", en: "No preferred supplier" },
  "rb.supplier": { es: "Proveedor", en: "Supplier" },
  "rb.subtotal": { es: "Subtotal", en: "Subtotal" },
  "rb.grandTotal": { es: "Total general", en: "Grand total" },
  // Consumo por área
  "nav.consumptionByArea": { es: "Consumo por Área", en: "Consumption by Area" },
  "cba.title": { es: "Consumo por Área", en: "Consumption by Area" },
  "cba.subtitle": { es: "¿Qué operación consume más? Movimientos MNT / IS / SH / AJ- de Cardex", en: "Which operation consumes most? MNT / IS / SH / AJ- Cardex movements" },
  "cba.grandCost": { es: "Costo total", en: "Total cost" },
  "cba.grandQty": { es: "Qty total", en: "Total qty" },
  "cba.areas": { es: "Áreas", en: "Areas" },
  "cba.avgDaily": { es: "Promedio diario", en: "Daily avg" },
  "cba.area": { es: "Área", en: "Area" },
  "cba.movements": { es: "Movimientos", en: "Movements" },
  "cba.equipments": { es: "Equipos", en: "Equipment" },
  "cba.topItems": { es: "Top artículos (por costo)", en: "Top items (by cost)" },
  "cba.topEquipment": { es: "Top equipos", en: "Top equipment" },
  "cba.window": { es: "Ventana", en: "Window" },
  // Pronóstico de compra
  "cba.forecast": { es: "Pronóstico de compra próximo trimestre", en: "Next-quarter purchase forecast" },
  "cba.growthFactor": { es: "Factor de crecimiento", en: "Growth factor" },
  "cba.growthHint": { es: "1.05 = +5%, 1.10 = +10%, 0.95 = -5%", en: "1.05 = +5%, 1.10 = +10%, 0.95 = -5%" },
  "cba.baseline": { es: "Base (sin crecimiento)", en: "Baseline (no growth)" },
  "cba.projected": { es: "Proyectado", en: "Projected" },
  "cba.growthDelta": { es: "Delta por crecimiento", en: "Growth delta" },
  "cba.projByArea": { es: "Proyección por área", en: "Projection by area" },
  "cba.projByFamily": { es: "Proyección por familia", en: "Projection by family" },
  "cba.byArea": { es: "Por área", en: "By area" },
  "cba.byFamily": { es: "Por familia", en: "By family" },
  "cba.family": { es: "Familia", en: "Family" },
  "cba.share": { es: "%", en: "%" },
  "cba.dailyAvg": { es: "Prom. diario", en: "Daily avg" },
  // Simulator bulk-supplier
  "sim.bulkAssign": { es: "Asignar proveedor a todos", en: "Assign supplier to all" },
  "sim.bulkAssignTitle": { es: "Asignar proveedor preferente en lote", en: "Bulk assign preferred supplier" },
  "sim.bulkHint": { es: "Elige el proveedor por artículo. Los que dejes vacíos permanecerán sin proveedor.", en: "Pick supplier per item. Empty ones will stay unassigned." },
  "sim.applyAllSame": { es: "Aplicar el mismo a todos", en: "Apply same to all" },
  "sim.saveAssignments": { es: "Guardar asignaciones", en: "Save assignments" },
  "sim.assignmentsSaved": { es: "{n} artículos actualizados", en: "{n} items updated" },
  // Resend tab
  "set.resend": { es: "Dominio Resend", en: "Resend Domain" },
  "set.resendSubtitle": { es: "Verifica tu dominio para enviar correos desde alertas@tu-dominio.com", en: "Verify your domain to send emails from alerts@your-domain" },
  "set.currentSender": { es: "Remitente actual", en: "Current sender" },
  "set.sandbox": { es: "SANDBOX", en: "SANDBOX" },
  "set.verified": { es: "VERIFICADO", en: "VERIFIED" },
  "set.steps": { es: "Pasos para verificar", en: "Verification steps" },
  "set.dnsRecords": { es: "Registros DNS a agregar", en: "DNS records to add" },
  "set.copy": { es: "Copiar", en: "Copy" },
  "set.copied": { es: "Copiado", en: "Copied" },
  "set.docs": { es: "Documentación Resend", en: "Resend docs" },
  "set.host": { es: "Host / Nombre", en: "Host / Name" },
  "set.value": { es: "Valor / Contenido", en: "Value / Content" },
  "set.purpose": { es: "Propósito", en: "Purpose" },
  "set.dnsCheck": { es: "Verificación DNS en vivo", en: "Live DNS check" },
  "set.dnsCheckNow": { es: "Verificar DNS ahora", en: "Check DNS now" },
  "set.dnsSandboxNote": { es: "Actualmente en sandbox (@resend.dev). Sigue los pasos, cambia SENDER_EMAIL a tu dominio, y luego regresa aquí para verificar.", en: "Currently in sandbox (@resend.dev). Follow the steps, change SENDER_EMAIL to your domain, then come back here to verify." },
  "set.dnsVerdict": { es: "Veredicto", en: "Verdict" },
  // ---------------- MAINTENANCE (Fase 14) ----------------
  "nav.maintenance": { es: "MANTENIMIENTO", en: "MAINTENANCE" },
  "nav.mnt.dashboard": { es: "Panel Mantenimiento", en: "Maintenance Panel" },
  "nav.mnt.notifications": { es: "Avisos", en: "Notifications" },
  "nav.mnt.workOrders": { es: "Órdenes de Trabajo", en: "Work Orders" },
  "nav.mnt.meters": { es: "Puntos de Medición", en: "Measurement Points" },
  "nav.mnt.history": { es: "Historial por Equipo", en: "Equipment History" },
  "nav.mnt.failures": { es: "Códigos de Falla", en: "Failure Codes" },
  // Common
  "mnt.equipment": { es: "Equipo", en: "Equipment" },
  "mnt.priority": { es: "Prioridad", en: "Priority" },
  "mnt.description": { es: "Descripción", en: "Description" },
  "mnt.selectEquipment": { es: "Selecciona un equipo", en: "Select equipment" },
  "mnt.reportedBy": { es: "Reportado por", en: "Reported by" },
  "mnt.reportedAt": { es: "Fecha reporte", en: "Reported at" },
  "mnt.close": { es: "Cerrar", en: "Close" },
  "mnt.actions": { es: "Acciones", en: "Actions" },
  "mnt.viewDetail": { es: "Ver detalle", en: "View detail" },
  // Priorities
  "mnt.p.low": { es: "Baja", en: "Low" },
  "mnt.p.med": { es: "Media", en: "Medium" },
  "mnt.p.high": { es: "Alta", en: "High" },
  "mnt.p.critical": { es: "Crítica", en: "Critical" },
  // Notifications
  "mnt.n.title": { es: "Avisos de Mantenimiento", en: "Maintenance Notifications" },
  "mnt.n.subtitle": { es: "Reportes de falla / solicitudes / mejoras — M1 M2 M3", en: "Failure reports / requests / improvements — M1 M2 M3" },
  "mnt.n.new": { es: "Nuevo aviso", en: "New notification" },
  "mnt.n.type": { es: "Tipo", en: "Type" },
  "mnt.n.type.M1": { es: "M1 Falla", en: "M1 Failure" },
  "mnt.n.type.M2": { es: "M2 Solicitud", en: "M2 Request" },
  "mnt.n.type.M3": { es: "M3 Mejora", en: "M3 Improvement" },
  "mnt.n.number": { es: "N° Aviso", en: "Notif #" },
  "mnt.n.symptom": { es: "Síntoma", en: "Symptom" },
  "mnt.n.cause": { es: "Causa (opcional)", en: "Cause (optional)" },
  "mnt.n.status.open": { es: "Abierto", en: "Open" },
  "mnt.n.status.reviewed": { es: "Revisado", en: "Reviewed" },
  "mnt.n.status.converted": { es: "Convertido a OT", en: "Converted to WO" },
  "mnt.n.status.closed": { es: "Cerrado", en: "Closed" },
  "mnt.n.convert": { es: "Convertir a OT", en: "Convert to WO" },
  "mnt.n.markReviewed": { es: "Marcar revisado", en: "Mark reviewed" },
  "mnt.n.linkedWo": { es: "OT vinculada", en: "Linked WO" },
  // Work Orders
  "mnt.wo.title": { es: "Órdenes de Trabajo", en: "Work Orders" },
  "mnt.wo.subtitle": { es: "OTs de mantenimiento: preventivo · correctivo · predictivo · emergencia", en: "Maintenance WOs: preventive · corrective · predictive · emergency" },
  "mnt.wo.new": { es: "Nueva OT", en: "New WO" },
  "mnt.wo.number": { es: "N° OT", en: "WO #" },
  "mnt.wo.type": { es: "Tipo", en: "Type" },
  "mnt.wo.type.PM01": { es: "PM01 Preventivo", en: "PM01 Preventive" },
  "mnt.wo.type.PM02": { es: "PM02 Correctivo", en: "PM02 Corrective" },
  "mnt.wo.type.PM03": { es: "PM03 Predictivo", en: "PM03 Predictive" },
  "mnt.wo.type.PM04": { es: "PM04 Emergencia", en: "PM04 Emergency" },
  "mnt.wo.status.created": { es: "Creada", en: "Created" },
  "mnt.wo.status.released": { es: "Liberada", en: "Released" },
  "mnt.wo.status.in_progress": { es: "En proceso", en: "In progress" },
  "mnt.wo.status.tech_completed": { es: "Téc. terminada", en: "Tech completed" },
  "mnt.wo.status.closed": { es: "Cerrada", en: "Closed" },
  "mnt.wo.status.cancelled": { es: "Cancelada", en: "Cancelled" },
  "mnt.wo.assigned": { es: "Asignada a", en: "Assigned to" },
  "mnt.wo.plannedStart": { es: "Inicio plan.", en: "Planned start" },
  "mnt.wo.plannedEnd": { es: "Fin plan.", en: "Planned end" },
  "mnt.wo.actualStart": { es: "Inicio real", en: "Actual start" },
  "mnt.wo.actualEnd": { es: "Fin real", en: "Actual end" },
  "mnt.wo.downtime": { es: "Horas fuera de servicio", en: "Downtime hours" },
  "mnt.wo.operations": { es: "Operaciones", en: "Operations" },
  "mnt.wo.op.seq": { es: "Seq", en: "Seq" },
  "mnt.wo.op.plannedH": { es: "Horas plan", en: "Planned h" },
  "mnt.wo.op.actualH": { es: "Horas reales", en: "Actual h" },
  "mnt.wo.op.done": { es: "Terminada", en: "Done" },
  "mnt.wo.op.add": { es: "Agregar operación", en: "Add operation" },
  "mnt.wo.materials": { es: "Materiales", en: "Materials" },
  "mnt.wo.mat.planned": { es: "Qty plan", en: "Planned qty" },
  "mnt.wo.mat.consumed": { es: "Qty consumida", en: "Consumed qty" },
  "mnt.wo.mat.unitCost": { es: "Costo unit.", en: "Unit cost" },
  "mnt.wo.mat.warehouse": { es: "Almacén", en: "Warehouse" },
  "mnt.wo.mat.add": { es: "Agregar material", en: "Add material" },
  "mnt.wo.mat.consume": { es: "Consumir ahora", en: "Consume now" },
  "mnt.wo.mat.consumed.ok": { es: "Consumo registrado en Cardex", en: "Consumption posted to Cardex" },
  "mnt.wo.rootCause": { es: "Causa raíz", en: "Root cause" },
  "mnt.wo.action": { es: "Acción correctiva", en: "Corrective action" },
  "mnt.wo.laborRate": { es: "Tarifa MO ($/h)", en: "Labor rate ($/h)" },
  "mnt.wo.laborCost": { es: "Costo M.O.", en: "Labor cost" },
  "mnt.wo.materialCost": { es: "Costo materiales", en: "Materials cost" },
  "mnt.wo.totalCost": { es: "Costo total", en: "Total cost" },
  "mnt.wo.release": { es: "Liberar", en: "Release" },
  "mnt.wo.start": { es: "Iniciar trabajo", en: "Start work" },
  "mnt.wo.techComplete": { es: "Marcar téc. terminada", en: "Tech complete" },
  "mnt.wo.confirmClose": { es: "Cerrar OT", en: "Close WO" },
  "mnt.wo.reopen": { es: "Reabrir", en: "Reopen" },
  "mnt.wo.cancel": { es: "Cancelar OT", en: "Cancel WO" },
  "mnt.wo.cancelDesc": { es: "La OT quedará cancelada: se liberan las reservas de material y no podrá reabrirse. Indica el motivo.", en: "The WO will be cancelled: material reservations are released and it cannot be reopened. State the reason." },
  "mnt.wo.cancelReason": { es: "Motivo de cancelación", en: "Cancellation reason" },
  "mnt.wo.cancelReasonPh": { es: "Ej. duplicada, equipo dado de baja, se atendió en otra OT…", en: "E.g. duplicate, equipment retired, handled in another WO…" },
  "mnt.wo.cancelled": { es: "OT cancelada", en: "WO cancelled" },
  "mnt.wo.cancelledBy": { es: "Cancelada por", en: "Cancelled by" },
  "mnt.wo.edit": { es: "Modificar OT", en: "Edit WO" },
  "mnt.wo.reopen": { es: "Reabrir OT", en: "Reopen WO" },
  "mnt.wo.reopenDesc": { es: "Solo administradores. La OT cancelada vuelve al estatus CREADA y el motivo queda en la bitácora.", en: "Admins only. The cancelled WO returns to CREATED and the reason is logged." },
  "mnt.wo.reopenReason": { es: "Motivo de la reapertura", en: "Reopen reason" },
  "mnt.wo.reopenReasonPh": { es: "Ej. cancelada por error, el trabajo sí se requiere…", en: "E.g. cancelled by mistake, the job is still required…" },
  "mnt.wo.reopened": { es: "OT reabierta", en: "WO reopened" },
  "mnt.wo.reopenedBy": { es: "Reabierta por", en: "Reopened by" },
  "mnt.wo.editDesc": { es: "Cambia tipo, prioridad, equipo, fechas, asignación o descripción. Los cambios quedan en la bitácora de la OT.", en: "Change type, priority, equipment, dates, assignment or description. Changes are logged in the WO history." },
  "mnt.wo.edited": { es: "OT actualizada", en: "WO updated" },
  "mnt.wo.linkedNotif": { es: "Aviso origen", en: "Source notification" },
  "mnt.wo.saved": { es: "OT guardada", en: "WO saved" },
  "mnt.wo.statusChanged": { es: "Estado actualizado", en: "Status updated" },
  // Meters
  "mnt.m.title": { es: "Puntos de Medición", en: "Measurement Points" },
  "mnt.m.subtitle": { es: "Contadores por equipo: horómetro · kilometraje · ciclos · presión · temperatura", en: "Per-equipment counters: hours · km · cycles · pressure · temp" },
  "mnt.m.new": { es: "Nuevo medidor", en: "New meter" },
  "mnt.m.code": { es: "Código", en: "Code" },
  "mnt.m.type": { es: "Tipo", en: "Type" },
  "mnt.m.type.hours": { es: "Horómetro", en: "Hour meter" },
  "mnt.m.type.km": { es: "Kilometraje", en: "Odometer" },
  "mnt.m.type.cycles": { es: "Ciclos", en: "Cycles" },
  "mnt.m.type.pressure": { es: "Presión", en: "Pressure" },
  "mnt.m.type.temp": { es: "Temperatura", en: "Temperature" },
  "mnt.m.type.custom": { es: "Personalizado", en: "Custom" },
  "mnt.m.uom": { es: "UOM", en: "UOM" },
  "mnt.m.lastReading": { es: "Última lectura", en: "Last reading" },
  "mnt.m.lastReadingAt": { es: "Fecha", en: "Date" },
  "mnt.m.addReading": { es: "Registrar lectura", en: "Add reading" },
  "mnt.m.reading": { es: "Lectura", en: "Reading" },
  "mnt.m.readings": { es: "Historial de lecturas", en: "Reading history" },
  "mnt.m.deleteConfirm": { es: "¿Eliminar el punto de medición y todas sus lecturas", en: "Delete meter and all its readings" },
  "mnt.m.deleteReadingConfirm": { es: "¿Eliminar la lectura", en: "Delete reading" },
  "mnt.m.readingSaved": { es: "Lectura registrada", en: "Reading saved" },
  // History
  "mnt.h.title": { es: "Historial por Equipo", en: "Equipment History" },
  "mnt.h.subtitle": { es: "Todas las OTs, avisos y medidores de un equipo", en: "All WOs, notifications and meters for one equipment" },
  "mnt.h.selectEq": { es: "Selecciona un equipo para ver historial", en: "Select an equipment to view history" },
  // Dashboard KPIs
  "mnt.k.title": { es: "Panel de Mantenimiento", en: "Maintenance Panel" },
  "mnt.k.subtitle": { es: "KPIs de mantenimiento — últimos 90 días", en: "Maintenance KPIs — last 90 days" },
  "mnt.k.mtbf": { es: "MTBF", en: "MTBF" },
  "mnt.k.mtbf.desc": { es: "Tiempo medio entre fallas (h)", en: "Mean time between failures (h)" },
  "mnt.k.mttr": { es: "MTTR", en: "MTTR" },
  "mnt.k.mttr.desc": { es: "Tiempo medio de reparación (h)", en: "Mean time to repair (h)" },
  "mnt.k.availability": { es: "Disponibilidad", en: "Availability" },
  "mnt.k.availability.desc": { es: "% disponible en ventana", en: "% available in window" },
  "mnt.k.cost": { es: "Costo total", en: "Total cost" },
  "mnt.k.cost.desc": { es: "OTs cerradas en ventana", en: "Closed WOs in window" },
  "mnt.k.failures": { es: "Fallas", en: "Failures" },
  "mnt.k.downtime": { es: "Downtime total (h)", en: "Total downtime (h)" },
  "mnt.k.openNotifs": { es: "Avisos abiertos", en: "Open notifications" },
  "mnt.k.byType": { es: "OTs por tipo", en: "WOs by type" },
  "mnt.k.byStatus": { es: "OTs por estado", en: "WOs by status" },
  // Failure codes
  "mnt.fc.title": { es: "Códigos de Falla", en: "Failure Codes" },
  "mnt.fc.subtitle": { es: "Catálogo de síntomas, causas y acciones", en: "Symptoms / causes / actions catalog" },
  "mnt.fc.seed": { es: "Sembrar catálogo minero", en: "Seed mining catalog" },
  "mnt.fc.new": { es: "Nuevo código", en: "New code" },
  "mnt.fc.category": { es: "Categoría", en: "Category" },
  "mnt.fc.cat.symptom": { es: "Síntoma", en: "Symptom" },
  "mnt.fc.cat.cause": { es: "Causa", en: "Cause" },
  "mnt.fc.cat.action": { es: "Acción", en: "Action" },
  "mnt.fc.seedDone": { es: "Códigos creados: {c} · Omitidos: {s}", en: "Codes created: {c} · Skipped: {s}" },

  // --- CMMS enhancements (2026) ---
  "nav.mnt.technicians": { es: "Mecánicos", en: "Mechanics" },
  "nav.mnt.failureLog": { es: "Bitácora de Fallas", en: "Failure Log" },

  // Notification type M4 preventive
  "mnt.n.type.M4": { es: "M4 Preventivo", en: "M4 Preventive" },
  "mnt.n.closeNotif": { es: "Cerrar aviso", en: "Close notification" },
  "mnt.n.createdAt": { es: "Fecha creación", en: "Created at" },

  // Affected system
  "mnt.n.affectedSystem": { es: "Sistema afectado", en: "Affected system" },
  "mnt.as.electrical": { es: "Eléctrico", en: "Electrical" },
  "mnt.as.engine": { es: "Motor", en: "Engine" },
  "mnt.as.transmission": { es: "Transmisión", en: "Transmission" },
  "mnt.as.hydraulic": { es: "Hidráulico", en: "Hydraulic" },
  "mnt.as.pneumatic": { es: "Neumático", en: "Pneumatic" },
  "mnt.as.brakes": { es: "Frenos", en: "Brakes" },
  "mnt.as.structural": { es: "Estructural", en: "Structural" },
  "mnt.as.cooling": { es: "Refrigeración", en: "Cooling" },
  "mnt.as.fuel": { es: "Combustible", en: "Fuel" },
  "mnt.as.steering": { es: "Dirección", en: "Steering" },
  "mnt.as.cabin": { es: "Cabina", en: "Cabin" },
  "mnt.as.other": { es: "Otro", en: "Other" },

  // Equipment master extras
  "eq.model": { es: "Modelo", en: "Model" },
  "eq.internalOrder": { es: "Orden Interna", en: "Internal Order" },
  "eq.viewInternalOrder": { es: "Ver Orden Interna", en: "View Internal Order" },
  "eq.viewWorkOrders": { es: "Ver Órdenes de Trabajo", en: "View Work Orders" },

  // Work Order technician
  "mnt.wo.technician": { es: "Mecánico (nombre)", en: "Mechanic (name)" },
  "mnt.wo.technicianDesc": { es: "Nombre libre de la persona que realizará el trabajo", en: "Free name of technician doing the job" },

  // Technicians master
  "mnt.tech.title": { es: "Maestro de Mecánicos", en: "Mechanics Master" },
  "mnt.tech.subtitle": { es: "Directorio de técnicos para asignar en órdenes de trabajo", en: "Technicians directory for work-order assignment" },
  "mnt.tech.new": { es: "Nuevo mecánico", en: "New mechanic" },
  "mnt.tech.name": { es: "Nombre", en: "Name" },
  "mnt.tech.position": { es: "Puesto", en: "Position" },
  "mnt.tech.email": { es: "Correo (opcional)", en: "Email (optional)" },
  "mnt.tech.phone": { es: "Teléfono", en: "Phone" },
  "mnt.tech.specialty": { es: "Especialidad", en: "Specialty" },

  // History date range + export
  "mnt.h.dateFrom": { es: "Desde", en: "From" },
  "mnt.h.dateTo": { es: "Hasta", en: "To" },
  "mnt.h.export": { es: "Descargar historial", en: "Download history" },

  // Internal Order
  "mnt.io.title": { es: "Orden Interna del Equipo", en: "Equipment Internal Order" },
  "mnt.io.subtitle": { es: "Refacciones y consumos acumulados por equipo", en: "Accumulated parts & consumption per equipment" },
  "mnt.io.number": { es: "N° Orden Interna", en: "Internal Order #" },
  "mnt.io.wosCount": { es: "OTs registradas", en: "Registered WOs" },
  "mnt.io.consumption": { es: "Consumos (Cardex)", en: "Consumption (Cardex)" },
  "mnt.io.totals": { es: "Totales acumulados", en: "Accumulated totals" },

  // Failure Log
  "mnt.fl.title": { es: "Bitácora de Fallas", en: "Failure Log" },
  "mnt.fl.subtitle": { es: "Registro histórico de fallas por número económico y fecha", en: "Historical failure log by economic number and date" },
  "mnt.fl.new": { es: "Registrar falla", en: "Log failure" },
  "mnt.fl.eventDate": { es: "Fecha del evento", en: "Event date" },
  "mnt.fl.economicNumber": { es: "N° Económico", en: "Economic #" },
  "mnt.fl.failureCode": { es: "Código de falla", en: "Failure code" },
  "mnt.fl.wo": { es: "OT relacionada", en: "Related WO" },

  // Export
  "common.export": { es: "Exportar", en: "Export" },
  "common.csv": { es: "CSV", en: "CSV" },
  "common.xlsx": { es: "Excel", en: "Excel" },
  "common.pdf": { es: "PDF", en: "PDF" },

  // Personnel
  "pn.title": { es: "Personal del Proyecto", en: "Project Personnel" },
  "pn.empNumber": { es: "No. empleado / RFC", en: "Employee no. / TaxID" },
  "pn.name": { es: "Nombre completo", en: "Full name" },
  "pn.department": { es: "Departamento", en: "Department" },
  "pn.position": { es: "Puesto", en: "Position" },
  "pn.email": { es: "Correo", en: "Email" },
  "pn.phone": { es: "Teléfono", en: "Phone" },
  "pn.project": { es: "Proyecto", en: "Project" },
  "pn.active": { es: "Activo", en: "Active" },
  "pn.inactive": { es: "Inactivo", en: "Inactive" },
  "pn.new": { es: "Nueva persona", en: "New person" },
  "pn.edit": { es: "Editar persona", en: "Edit person" },
  "pn.template": { es: "Descargar plantilla", en: "Download template" },
  "pn.import": { es: "Importar CSV/XLSX", en: "Import CSV/XLSX" },
  "pn.deactivate": { es: "Desactivar", en: "Deactivate" },
  "pn.searchPh": { es: "Buscar por nombre, número, correo…", en: "Search by name, number, email…" },
  "pn.imported": { es: "Importado", en: "Imported" },
  "pn.updated": { es: "Actualizado", en: "Updated" },
  "pn.created": { es: "Creado", en: "Created" },

  // Departments
  "dept.title": { es: "Departamentos", en: "Departments" },
  "dept.code": { es: "Código", en: "Code" },
  "dept.name": { es: "Nombre", en: "Name" },
  "dept.new": { es: "Nuevo departamento", en: "New department" },
  "dept.edit": { es: "Editar departamento", en: "Edit department" },

  // Vales de Salida (Exit Vouchers)
  "vs.title": { es: "Vales de Salida", en: "Exit Vouchers" },
  "vs.new": { es: "Nuevo vale", en: "New voucher" },
  "vs.edit": { es: "Editar vale", en: "Edit voucher" },
  "vs.folio": { es: "Folio", en: "Number" },
  "vs.date": { es: "Fecha", en: "Date" },
  "vs.generator": { es: "Generador", en: "Generator" },
  "vs.department": { es: "Departamento", en: "Department" },
  "vs.requester": { es: "Solicitante", en: "Requester" },
  "vs.authorizer": { es: "Autorizador", en: "Authorizer" },
  "vs.authorizedAt": { es: "Fecha autorización", en: "Authorized at" },
  "vs.notes": { es: "Observaciones", en: "Notes" },
  "vs.lines": { es: "Partidas", en: "Lines" },
  "vs.item": { es: "Código", en: "Code" },
  "vs.equipment": { es: "Equipo (cargo directo)", en: "Equipment (direct charge)" },
  "vs.equipRequired": { es: "Equipo obligatorio para refacciones", en: "Equipment required for spare parts" },
  "vs.saveDraft": { es: "Guardar en captura", en: "Save draft" },
  "vs.submit": { es: "Enviar a autorización", en: "Submit for authorization" },
  "vs.authorize": { es: "Autorizar", en: "Authorize" },
  "vs.reject": { es: "Rechazar", en: "Reject" },
  "vs.cancel": { es: "Cancelar", en: "Cancel" },
  "vs.reason": { es: "Motivo", en: "Reason" },
  "vs.rejectionReason": { es: "Motivo de rechazo", en: "Rejection reason" },
  "vs.print": { es: "Imprimir carátula", en: "Print cover" },
  "vs.downloadPdf": { es: "Descargar PDF", en: "Download PDF" },
  "vs.searchPh": { es: "Buscar folio, solicitante, depto…", en: "Search number, requester, dept…" },
  "dept.approvers": { es: "Personal autorizado (aprobadores)", en: "Authorized approvers" },
  "dept.position": { es: "Puesto", en: "Position" },
  "dept.addApprover": { es: "Agregar autorizado", en: "Add approver" },
  "dept.approversHint": { es: "Solo usuarios con rol Aprobador o Admin. Aparecerán como opciones al elegir este departamento en una requisición.", en: "Only users with Approver/Admin role. Shown when this department is selected on a requisition." },
  "rq.priority": { es: "Prioridad", en: "Priority" },
  "rq.prio.urgent": { es: "Urgente", en: "Urgent" },
  "rq.prio.normal": { es: "Normal", en: "Normal" },
  "rq.prio.low": { es: "Baja", en: "Low" },
  "rq.warehouse": { es: "Almacén de destino", en: "Destination warehouse" },
  "rq.attachments": { es: "Archivos adjuntos", en: "Attachments" },
  "rq.attachmentsDraftHint": { es: "Guarda el borrador para poder adjuntar archivos (imágenes, PDF, Excel).", en: "Save the draft to attach files (images, PDF, Excel)." },
  "rq.signWithToken": { es: "Firmar con token", en: "Sign with token" },
  "rq.signToken": { es: "Token de firma", en: "Signature token" },
  "rq.signHint": { es: "Ingresa tu token personal de firma (Ajustes → Mi firma digital). Puedes continuar sin firma digital.", en: "Enter your personal signing token (Settings → My digital signature). You may continue without digital signature." },
  "rq.signedDigitally": { es: "Firmado digitalmente", en: "Digitally signed" },
  "rq.approveAndSign": { es: "Aprobar y firmar", en: "Approve & sign" },
  "rq.noApproversDept": { es: "Este departamento no tiene personal autorizado; se muestran todos los aprobadores.", en: "This department has no authorized approvers; showing all approvers." },
  "po.edit": { es: "Editar OC", en: "Edit PO" },
  "po.quotation": { es: "No. de cotización", en: "Quotation no." },
  "po.deliveryDate": { es: "Fecha de entrega", en: "Delivery date" },
  "po.paymentTerms": { es: "Condiciones de pago", en: "Payment terms" },
  "po.shipTo": { es: "Enviar a (almacén)", en: "Ship to (warehouse)" },
  "po.taxRate": { es: "IVA %", en: "VAT %" },
  "po.subtotal": { es: "Subtotal", en: "Subtotal" },
  "po.tax": { es: "IVA", en: "VAT" },
  "po.shipping": { es: "Envío", en: "Shipping" },
  "po.others": { es: "Otros", en: "Others" },
  "po.notesHint": { es: "Instrucciones de envío, al proveedor o al transportista", en: "Shipping, supplier or carrier instructions" },
  "po.reqAttachments": { es: "Adjuntos de la requisición", en: "Requisition attachments" },
  "po.attachments": { es: "Documentación de la OC (cotización, manuales, imágenes)", en: "PO documents (quotation, manuals, images)" },
  "po.pdf": { es: "PDF OC", en: "PO PDF" },
  "po.save": { es: "Guardar cambios", en: "Save changes" },
  "rc.lineLocation": { es: "Ubicación por partida", en: "Location per line" },
  "rc.sameLocation": { es: "Igual que la cabecera", en: "Same as header" },
  "ab.taxRate": { es: "IVA del proveedor", en: "Supplier VAT" },
  "ab.paymentTerms": { es: "Condiciones de pago (ej. N30)", en: "Payment terms (e.g. N30)" },
  "it.image": { es: "Imagen del producto", en: "Product image" },
  "it.imageUpload": { es: "Subir imagen", en: "Upload image" },
  "it.imageHint": { es: "PNG/JPG hasta 5 MB. Ayuda a identificar el producto al recibir.", en: "PNG/JPG up to 5 MB. Helps identify the product at receiving." },
  "it.imageRemove": { es: "Quitar imagen", en: "Remove image" },
  "set.companyDocs": { es: "Datos de la empresa para documentos (REQ / OC)", en: "Company data for documents (REQ / PO)" },
  "set.companyAddress": { es: "Dirección", en: "Address" },
  "set.companyRfc": { es: "RFC", en: "Tax ID (RFC)" },
  "set.companyEmail": { es: "Correo (facturas)", en: "Email (invoices)" },
  "set.companyPhone": { es: "Teléfono", en: "Phone" },
  "set.paymentPolicy": { es: "Política de pagos (2ª hoja de la OC)", en: "Payment policy (PO page 2)" },
  "set.poFooter": { es: "Nota al pie de la OC", en: "PO footer note" },
  "set.mySignature": { es: "Mi firma digital", en: "My digital signature" },
  "set.signatureImage": { es: "Imagen de firma (PNG/JPG)", en: "Signature image (PNG/JPG)" },
  "set.signatureToken": { es: "Token de firma", en: "Signing token" },
  "set.generateToken": { es: "Generar nuevo token", en: "Generate new token" },
  "set.tokenHint": { es: "El token se muestra una sola vez. Guárdalo; lo necesitarás para firmar aprobaciones. Generar uno nuevo invalida el anterior.", en: "Token is shown only once. Keep it; you'll need it to sign approvals. Generating a new one invalidates the previous." },
  "set.tokenConfigured": { es: "Token configurado", en: "Token configured" },
  "set.tokenMissing": { es: "Sin token", en: "No token" },
  "set.signatureFor": { es: "Firma de usuario (admin)", en: "User signature (admin)" },
  "po.sendEmail": { es: "Enviar al proveedor", en: "Send to supplier" },
  "po.sendEmailHint": { es: "Se enviará el PDF de la OC (con política de pagos) como adjunto. Las respuestas llegarán a tu correo.", en: "The PO PDF (with payment policy) will be attached. Replies go to your email." },
  "po.emailTo": { es: "Destinatario(s)", en: "Recipient(s)" },
  "po.emailMessage": { es: "Mensaje adicional", en: "Additional message" },
  "po.emailSent": { es: "OC enviada", en: "PO sent" },
  "po.sentOn": { es: "Enviada al proveedor el", en: "Sent to supplier on" },
  "wh.edit": { es: "Editar almacén", en: "Edit warehouse" },
  "wh.new": { es: "Nuevo almacén", en: "New warehouse" },
  "wh.newHint": { es: "Código corto único (ej. ALM-01, PA-TALLER), nombre, sucursal/sitio y dirección de entrega para las OCs.", en: "Unique short code (e.g. ALM-01), name, site and delivery address for POs." },
  "wh.code": { es: "Código", en: "Code" },
  "wh.branch": { es: "Sucursal / sitio", en: "Site" },
  "wh.created": { es: "Almacén creado. Ahora agrega sus ubicaciones (racks / bins).", en: "Warehouse created. Now add its locations." },
  "wh.deleteConfirm": { es: "¿Eliminar el almacén", en: "Delete warehouse" },
  "wh.none": { es: "Sin almacenes registrados", en: "No warehouses yet" },
  "wh.editHint": { es: "Estos datos se usan en el bloque ENVIAR A de la orden de compra.", en: "Used in the SHIP TO block of the purchase order." },
  "wh.name": { es: "Nombre del almacén", en: "Warehouse name" },
  "wh.email": { es: "Correo", en: "Email" },
  "wh.noAddress": { es: "Sin dirección (se usará la de la empresa)", en: "No address (company address will be used)" },
  "set.senderEmail": { es: "Remitente de correos", en: "Sender email" },
  "set.senderHint": { es: "Debe pertenecer a un dominio verificado en Resend. Se aplica de inmediato a todos los correos (OC, alertas, notificaciones).", en: "Must belong to a Resend-verified domain. Applies immediately to all emails." },
  "set.senderSaved": { es: "Remitente guardado", en: "Sender saved" },
  "set.testEmail": { es: "Correo de prueba", en: "Test email" },
  "set.sendTest": { es: "Enviar prueba", en: "Send test" },
  "set.testSent": { es: "Correo de prueba enviado", en: "Test email sent" },
  "set.testEmailHint": { es: "En modo sandbox Resend solo entrega al correo del dueño de la cuenta.", en: "In sandbox mode Resend only delivers to the account owner email." },
  "po.supplierConf": { es: "Confirmación del proveedor", en: "Supplier confirmation" },
  "po.conf.sent": { es: "Pendiente de confirmación", en: "Awaiting confirmation" },
  "po.conf.confirmed": { es: "Confirmada por el proveedor", en: "Confirmed by supplier" },
  "po.conf.proposed": { es: "Proveedor propone otra fecha", en: "Supplier proposes new date" },
  "po.conf.rejected": { es: "Rechazada por el proveedor", en: "Rejected by supplier" },
  "po.acceptDate": { es: "Aceptar fecha propuesta", en: "Accept proposed date" },
  "po.copyLink": { es: "Copiar enlace de confirmación", en: "Copy confirmation link" },
  "po.overdue": { es: "Vencida", en: "Overdue" },
  "po.runReminders": { es: "Revisar entregas vencidas", en: "Check overdue deliveries" },
  "po.filterOverdue": { es: "Entregas vencidas", en: "Overdue deliveries" },
  "po.filterResponses": { es: "Respuestas de proveedor por atender", en: "Supplier responses to handle" },
  "po.ackResponse": { es: "Marcar atendida", en: "Mark handled" },
  "po.remindersSent": { es: "Recordatorios enviados al proveedor", en: "Reminders sent to supplier" },
  "ab.evaluation": { es: "Evaluación", en: "Rating" },
  "qt.title": { es: "Comparativo de cotizaciones", en: "Quote comparison" },
  "qt.new": { es: "Capturar cotización", en: "Add quote" },
  "qt.edit": { es: "Editar cotización", en: "Edit quote" },
  "qt.empty": { es: "Sin cotizaciones. Captura al menos dos para comparar precios y tiempos de entrega.", en: "No quotes yet. Add at least two to compare prices and lead times." },
  "qt.hint": { es: "Captura el precio unitario cotizado por partida. El mejor precio por artículo y el menor total se resaltan en verde.", en: "Enter the quoted unit price per line. Best price per item and lowest total are highlighted." },
  "qt.prices": { es: "Precios cotizados (cantidad · precio unitario)", en: "Quoted prices (qty · unit price)" },
  "qt.deliveryDays": { es: "Tiempo de entrega (días)", en: "Lead time (days)" },
  "qt.bestPrices": { es: "mejores precios", en: "best prices" },
  "qt.fastest": { es: "más rápida", en: "fastest" },
  "qt.winner": { es: "Ganadora", en: "Winner" },
  "qt.select": { es: "Elegir ganadora", en: "Select winner" },
  "qt.unselect": { es: "Quitar selección", en: "Unselect" },
  "qt.selected": { es: "Cotización ganadora seleccionada", en: "Winning quote selected" },
  "qt.withWinner": { es: "con cotización ganadora", en: "with winning quote" },
  "rfq.title": { es: "Solicitar cotización", en: "Request for quote" },
  "rfq.hint": { es: "Se enviará por correo la lista de artículos y cantidades a cada proveedor seleccionado; las respuestas llegarán a tu correo.", en: "Items and quantities will be emailed to each selected supplier; replies go to your email." },
  "rfq.noEmail": { es: "sin correo", en: "no email" },
  "rfq.alreadySent": { es: "Ya solicitada", en: "Already sent" },
  "rfq.deadline": { es: "Fecha límite", en: "Deadline" },
  "rfq.history": { es: "Solicitudes enviadas", en: "Requests sent" },
  "rfq.send": { es: "Enviar solicitud", en: "Send request" },
  "rfq.sent": { es: "Solicitud enviada", en: "Request sent" },
  "ph.last": { es: "Último pagado", en: "Last paid" },
  "ph.thisSupplier": { es: "este proveedor", en: "this supplier" },
  "ph.min": { es: "Mín 12m", en: "Min 12m" },
  "ph.avg": { es: "Prom", en: "Avg" },
  "sv.title": { es: "Reporte de ahorros por cotización", en: "Quote savings report" },
  "sv.hint": { es: "Compara el subtotal de la cotización ganadora contra el costo estimado de la requisición y contra el promedio de las cotizaciones recibidas.", en: "Winning quote subtotal vs requisition estimate and vs average of received quotes." },
  "sv.reqs": { es: "Requisiciones", en: "Requisitions" },
  "sv.vsEst": { es: "Ahorro vs estimado", en: "Savings vs estimate" },
  "sv.vsAvg": { es: "Ahorro vs promedio", en: "Savings vs average" },
  "sv.vsHighest": { es: "Ahorro vs más cara", en: "Savings vs highest" },
  "sv.est": { es: "Estimado", en: "Estimate" },
  "sv.avg": { es: "Promedio", en: "Average" },
  "sv.winnerTotal": { es: "Ganadora", en: "Winner" },
  "rq.savings": { es: "Ahorros", en: "Savings" },
  "set.verifiedDomains": { es: "Dominios en tu cuenta Resend (clic para usar)", en: "Domains in your Resend account (click to use)" },
  "set.position": { es: "Puesto", en: "Position" },
  "set.bulkUsers": { es: "Alta masiva", en: "Bulk import" },
  "set.bulkHint": { es: "Pega una línea por usuario: Nombre, correo, puesto, rol (admin / comprador / aprobador / almacén / mantenimiento / visor). Todos reciben la misma contraseña inicial.", en: "Paste one line per user: Name, email, position, role (admin / buyer / approver / warehouse / maintenance / viewer). All get the same initial password." },
  "set.bulkPassword": { es: "Contraseña inicial (mín. 8)", en: "Initial password (min 8)" },
  "set.bulkWelcome": { es: "Enviar correo de bienvenida con acceso", en: "Send welcome email with credentials" },
  "set.bulkWelcomeStatus": { es: "Correo bienvenida", en: "Welcome email" },
  "set.bulkCreated": { es: "usuarios creados", en: "users created" },
  "set.bulkErrors": { es: "errores", en: "errors" },
  "set.bulkInvalid": { es: "Inválido", en: "Invalid" },
  "set.domains": { es: "Dominios en Resend", en: "Domains in Resend" },
  "set.addDomain": { es: "Agregar dominio", en: "Add domain" },
  "set.domainAdded": { es: "Dominio agregado en Resend", en: "Domain added in Resend" },
  "set.domainVerified": { es: "¡Dominio verificado! Remitente activado.", en: "Domain verified! Sender activated." },
  "set.domainStatus": { es: "Estatus del dominio", en: "Domain status" },
  "set.noDomains": { es: "Sin dominios en la cuenta", en: "No domains in account" },
  "set.verifyNow": { es: "Verificar en Resend", en: "Verify in Resend" },
  "set.dnsExactHint": { es: "Captura estos registros EXACTOS en el DNS de tu dominio (GoDaddy, Cloudflare, etc.). Luego pulsa \"Verificar en Resend\". La propagación puede tardar de minutos a 48 h.", en: "Add these EXACT records in your domain DNS (GoDaddy, Cloudflare, etc.). Then click \"Verify in Resend\". Propagation may take minutes to 48 h." },
  "set.recordType": { es: "Tipo", en: "Type" },
  "set.pendingSender": { es: "Remitente a activar al verificar", en: "Sender to activate once verified" },
  "set.pendingSenderHint": { es: "Cuando el dominio quede verificado, el sistema cambiará automáticamente el remitente de todos los correos a esta dirección.", en: "Once the domain is verified the system will automatically switch all outgoing email to this sender." },
  "set.pendingSaved": { es: "Remitente pendiente guardado — se activará al verificar el dominio", en: "Pending sender saved — activates when domain is verified" },
  "set.pendingApplied": { es: "Dominio ya verificado: remitente activado", en: "Domain already verified: sender activated" },
  "set.digest": { es: "Resumen diario · Mi Escritorio", en: "Daily digest · My Desk" },
  "set.digestSubtitle": { es: "Cada mañana cada usuario recibe UN solo correo con todos sus pendientes (requisiciones, vales, OTs, OCs vencidas, facturas, avisos). Solo se envía si tiene pendientes.", en: "Every morning each user gets ONE email with everything pending for them. Only sent when there is something pending." },
  "set.digestHour": { es: "Hora de envío", en: "Send hour" },
  "set.digestHourHint": { es: "El horario real lo fija el cron del servidor (7:00 Chihuahua). Este valor es informativo.", en: "Actual time is set by the server cron (7:00 Chihuahua). This value is informative." },
  "set.digestRecipients": { es: "Destinatarios", en: "Recipients" },
  "set.digestSendMe": { es: "Enviármelo ahora", en: "Send me now" },
  "set.digestSendAll": { es: "Enviar a todos ahora", en: "Send to all now" },
  "set.digestSentMe": { es: "Resumen enviado a tu correo", en: "Digest sent to your email" },
  "set.digestEmpty": { es: "No tienes pendientes: no se envió correo", en: "Nothing pending: no email sent" },
  "set.digestConfirmAll": { es: "¿Enviar el resumen diario a TODOS los usuarios activos ahora mismo?", en: "Send the daily digest to ALL active users right now?" },
  "set.digestSentAll": { es: "Enviados", en: "Sent" },
  "set.digestSentLbl": { es: "enviados", en: "sent" },
  "set.digestSkipped": { es: "sin pendientes", en: "nothing pending" },
  "set.dailyDigestPref": { es: "Recibir resumen diario de Mi Escritorio por correo (7:00 am)", en: "Receive daily My Desk digest by email (7:00 am)" },
  "set.emailNotifications": { es: "Recibir por correo las asignaciones y avisos (requisiciones, OCs, vales, OTs)", en: "Receive assignments and alerts by email (requisitions, POs, vouchers, WOs)" },
  "po.remindersDone": { es: "OCs vencidas notificadas", en: "Overdue POs notified" },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("erp_lang") || "es");
  const t = (key) => dict[key]?.[lang] || key;
  const changeLang = (l) => { setLang(l); localStorage.setItem("erp_lang", l); };
  // Keep <html lang="…"> in sync with the app language so browsers do NOT
  // auto-translate Spanish content when the OS/browser language is different.
  // Google Translate wrapping text nodes with <font> tags is a well-known
  // trigger for React's "removeChild … not a child of this node" crashes.
  useEffect(() => {
    if (typeof document !== "undefined" && document.documentElement) {
      document.documentElement.setAttribute("lang", lang);
      document.documentElement.setAttribute("translate", "no");
    }
  }, [lang]);
  return <I18nContext.Provider value={{ lang, setLang: changeLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
